import React from "react";
import { Container, Row, Col, Table } from "react-bootstrap";
import PropTypes from "prop-types";
import WorkOrderCompletedWorkItem from "./WorkOrderCompletedWorkItem";
import "./WorkOrderCompletedWorkItems.css";
import { completed } from "./States";

function WorkOrderCompletedWorkItems({ property, workOrder }) {
  const completedWorkItems = workOrder.workItems.filter((workItem) =>
    completed.includes(workItem.status)
  );

  if (completedWorkItems.length === 0) {
    return (
      <Row>
        <Col>No completed work items</Col>
      </Row>
    );
  }

  return (
    <Container className="coreContent mt-4">
      <Row>
        <Col>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Reference</th>
                <th>Type</th>
                <th>WI Notes</th>
                <th>Created</th>
                <th>Closed</th>
                <th>Category</th>
                <th>Sub-Category</th>
                <th>Status</th>
                <th>Cancellation Reason</th>
                <th>Cancelled By</th>
              </tr>
            </thead>
            <tbody>
              {completedWorkItems
                .sort((a, b) => {
                  if (new Date(a.createdOn) < new Date(b.createdOn)) return 1;
                  if (new Date(a.createdOn) > new Date(b.createdOn)) return -1;
                  return 0;
                })
                .map((workItem) => (
                  <WorkOrderCompletedWorkItem
                    key={workItem.reference}
                    property={property}
                    workOrder={workOrder}
                    workItem={workItem}
                  />
                ))}
            </tbody>
          </Table>
        </Col>
      </Row>
    </Container>
  );
}

WorkOrderCompletedWorkItems.propTypes = {
  property: PropTypes.shape({ id: PropTypes.string }).isRequired,
  workOrder: PropTypes.shape({
    workItems: PropTypes.arrayOf(
      PropTypes.shape({ reference: PropTypes.string })
    ),
  }).isRequired,
};

export default WorkOrderCompletedWorkItems;
